const pre = '/UI/subscriptions/';
export default {
  INIT_REQUIRED_PLANS: `${pre}INIT_REQUIRED_PLANS`,
  ADD_REQUIRED_PLAN: `${pre}ADD_REQUIRED_PLAN`
};